<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/833F2u/tc-custom/9780061865923.jpg?1716663165631" alt="This image is the cover for the book Nectar"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nectar
      </h1>
      <p class="bookDescription body article font2">
        <p>Ramona Drottoveo, an albino, is a chambermaid at a lush Italian estate. Distinguished by the intoxicating scent she exudes, Ramona is despised by all women and adored by all men, whose inexhaustible lust she eagerly satisfies. Life changes when her husband dies after discovering his bride with another man on their wedding night. Blamed for his death, Ramona and her lover are exiled to the neighboring city of Naples. There, Ramona's life is transformed once again by the birth of a daughter, Blandina, who "steals" her mother's scent. No longer able to seduce men into blind submission, Ramona humbly returns to the estate to an unexpected welcome -- and revenge. </p><p>A hilarious and naughty celebration of the senses and the strange places they can lead us, Nectar explores the mystery of sexual attraction and the frivolous nature of divine justice.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lily Prior
      </h2>
      
      <p class="authorDescription body article"><P>Lily Prior is the author of <I>La Cucina, Ardor,</I> and <I>Nectar</I> and she divides her time between London and Italy.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a3fafe20